/** @module modules/grants/locales */

import en from './en'

export default {
  en,
}
